import { EntitiesAndAccounts } from '~/lib/roles/useEntitiesAndAccounts';
import { CreateCustomRoleRequestObject, UpdateCustomRoleRequestObject } from '~/typings/API';

// Gets the subset of the request that only contains sandbox/live entities and accounts.
export const buildCreateRequestForEntitiesAndAccountsSubset = (
  data: CreateCustomRoleRequestObject,
  entitiesAndAccountsSubset: EntitiesAndAccounts
): CreateCustomRoleRequestObject => ({
  ...data,
  entityLevelOverrides: data.entityLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.entities.data.some((entity) => entity.id === override.entityId)
  ),
  bankAccountLevelOverrides: data.bankAccountLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.bankAccounts.data.some((bankAccount) => bankAccount.id === override.bankAccountId)
  ),
});

export const buildUpdateRequestForEntitiesAndAccountsSubset = (
  data: UpdateCustomRoleRequestObject,
  entitiesAndAccountsSubset: EntitiesAndAccounts
): UpdateCustomRoleRequestObject => ({
  ...data,
  entityLevelOverrides: data.entityLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.entities.data.some((entity) => entity.id === override.entityId)
  ),
  bankAccountLevelOverrides: data.bankAccountLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.bankAccounts.data.some((bankAccount) => bankAccount.id === override.bankAccountId)
  ),
});
